import { NativeStackHeaderProps, Stack } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import ShowMoreAccordian from 'shared/components/ShowMoreAccordian/ShowMoreAccordion';
import ContentList from 'shared/components/vxl/ContentList/ContentList';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import ActionScreen from 'shared/patterns/vxl/ActionScreen/ActionScreen';
import theme from 'shared/styles/theme';

const ACCORDION_MAX_LENGTH = 115;

const CardBenefitsScreen = () => {
  const { t: translatedText } = useTranslation('believe', {
    keyPrefix: 'learningCenter',
  });

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          headerBackVisible: true,
          headerShown: true,
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar {...props} />
          ),
        }}
      />
      <ActionScreen
        visual="BELIEVE_CARD_A_ANIMATED"
        titleText={translatedText('cardBenefits.title')}
        titleTextStyle="extra-large"
        bodyContent={
          <View style={styles.bodyContainer}>
            <BodyBaseText>
              {translatedText('cardBenefits.description')}
            </BodyBaseText>
            <ContentList
              contentList={[
                translatedText('cardBenefits.bullets.one'),
                translatedText('cardBenefits.bullets.two'),
                translatedText('cardBenefits.bullets.three'),
                translatedText('cardBenefits.bullets.four'),
                translatedText('cardBenefits.bullets.five'),
              ]}
            />
            <ShowMoreAccordian
              text={translatedText('cardBenefits.conditions')}
              maxLength={ACCORDION_MAX_LENGTH}
            />
          </View>
        }
      />
    </View>
  );
};

const styles = StyleSheet.create({
  bodyContainer: {
    rowGap: theme.spacing.m,
  },
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
});

export default CardBenefitsScreen;
